import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoNetflix = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 112 48"
    {...props}
  >
    <g clipPath="url(#Logo_Netflix_svg__a)">
      <path
        fill="#D81F26"
        d="M15.879 38.066c-1.67.293-3.37.381-5.127.616L5.39 22.979v16.377c-1.67.175-3.193.41-4.775.644V10h4.453l6.094 17.022V10h4.717zm9.228-17.08c1.817 0 4.6-.088 6.27-.088v4.688c-2.08 0-4.512 0-6.27.088v6.973c2.754-.176 5.508-.41 8.291-.499v4.512L20.42 37.685V10H33.4v4.688h-8.292zm25.723-6.298h-4.863V36.25c-1.583 0-3.165 0-4.688.059V14.688h-4.863V10H50.83zm7.617 5.976h6.416v4.688h-6.416v10.634h-4.6V10h13.096v4.688h-8.496zm16.113 11.22c2.666.06 5.361.265 7.969.41v4.63c-4.19-.264-8.379-.527-12.656-.615V10h4.687zm11.924 5.362c1.494.088 3.076.176 4.6.351V10h-4.6zM111.621 10l-5.948 14.268L111.621 40c-1.758-.234-3.516-.557-5.274-.85l-3.369-8.671-3.427 7.968c-1.7-.293-3.34-.38-5.04-.615l6.036-13.74L95.097 10h5.039l3.076 7.88 3.282-7.88z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Netflix_svg__a">
        <path
          fill="#fff"
          d="M.615 0h111v48h-111z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoNetflix;
